import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  emitUpdate() {
    document.dispatchEvent(new CustomEvent("calendarChange"));
  }
}
